import React from "react";
import { firebase, auth, firestore } from "../utils/firebase";

//使用google授權
const signInWithGoogle = () => {
  console.log("sign");
  const provider = new firebase.auth.GoogleAuthProvider();
  auth.useDeviceLanguage();
  auth
    .signInWithPopup(provider)
    .then(async (result) => {
      const user = result.user;
      const docRef = firestore.collection("users").doc(user.uid);
      await docRef.get().then((doc) => {
        //會員存在，紀錄資料並且重導向到首頁
        if (doc.exists) {
          //window.location.reload();
          return;
        }
        docRef.set({
          id: user.uid,
          name: user.displayName,
          email: user.email,
          photoURL: user.photoURL,
          verification: false,
          introduction: "暫無介紹",
        });
        //window.location.reload();
        return;
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

function SignInPage() {
  return <div></div>;
}

export { signInWithGoogle, SignInPage };
